import "./style.scss";

import { Box } from "@mui/material";
import { Spinner } from "components/shared/Spinner";
import StyledButton from "components/shared/StyledButton";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useCompanySettings } from "hooks/useCompanySettings";
import { fetchBeneficiariesInformation, fetchStats } from "store/managementStore";
import { fetchPeriods, putMinimum } from "store/periodStore";
import { useAppDispatch, useAppSelector } from "store/store";

type TProps = {
    close: () => void;
};
const SetMinimum = ({ close }: TProps) => {
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const { activePeriod, periods } = useAppSelector((state) => state.period);
    const { currencySymbol } = useCompanySettings();
    const [amount, setAmount] = React.useState("0.00");
    const [isLoading, setIsLoading] = React.useState(false);
    const handleChangeAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAmount(e.target.value);
    };

    useEffect(() => {
        const currentPeriod = periods.find((p) => p.id === activePeriod);

        if (currentPeriod) {
            setAmount((currentPeriod.minimum / 100).toString());
        }
    }, [periods, activePeriod]);

    const handleSubmit = () => {
        setIsLoading(true);
        dispatch(putMinimum({ amount: +amount, period: activePeriod })).then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
                if (activePeriod) {
                    dispatch(fetchBeneficiariesInformation({ periodId: activePeriod }));
                    dispatch(fetchPeriods());
                    dispatch(fetchStats(activePeriod));
                }
                setIsLoading(false);
                close();
            }
        });
    };

    return (
        <div className="set-minimum">
            <div className="set-minimum-input">
                <label htmlFor=""></label>
                <StyledTextField
                    fullWidth
                    value={amount}
                    onChange={handleChangeAmount}
                    placeholder={"0,00"}
                    InputProps={{
                        endAdornment: (
                            <span
                                style={{
                                    color: "#585858",
                                    fontWeight: "600",
                                    marginLeft: "10px",
                                }}
                            >
                                {currencySymbol}
                            </span>
                        ),
                    }}
                />
            </div>
            <div className="set-minimum-info">
                <ul className="set-minimum-info-list">
                    <li>{t("Management.SetMinimumInfoFirst")}</li>
                    <li>{t("Management.SetMinimumInfoSecond")}</li>
                    <li>{t("Management.SetMinimumInfoThird")}</li>
                </ul>
            </div>
            {isLoading ? (
                <Box
                    sx={{
                        display: "flex",
                        height: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Spinner />
                </Box>
            ) : (
                <StyledButton
                    fullWidth
                    buttonType="primary"
                    disabled={isNaN(+amount) || isLoading}
                    onClick={handleSubmit}
                >
                    {t("Management.Next")}
                </StyledButton>
            )}
        </div>
    );
};

export default SetMinimum;
